import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import type { SidebarItem } from '@/lib/types/sidebar';
import { sidebarGrantsPath, subscribeSidebarConfig } from '@/lib/access/sidebarPageAccess';

/**
 * Whether the live sidebar config grants the current (or given) path
 * to the signed-in user's roles.
 */
export function useSidebarPathAccess(pathname?: string) {
  const { currentUser } = useAuth();
  const location = useLocation();
  const path = pathname || location.pathname;
  const [items, setItems] = useState<SidebarItem[] | null>(null);

  useEffect(() => subscribeSidebarConfig(setItems), []);

  const loading = items === null;
  const granted = !loading && sidebarGrantsPath(items, path, currentUser?.roles);

  return { loading, granted };
}
